import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class ParagraphProgressFacade {
  private readonly store: Store = inject(Store);
}
